// AI Generated Component
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalPolicyExchangeCenterTemplateService } from '@client/app/modules/global-policy/services/global-policy-exchange-center-template.service';

@Component({
    selector: 'policy-exchange-center-views-list',
    standalone: false,
    template: `
        <div class="policy-exchange-center-views-list">
            <div *ngIf="templates.length === 0">
                <h3 class="font-weight-300 text-grey text-center my-8"
                    [attr.aria-label]="'No content was found' | translate"
                    translate>
                    No content was found
                </h3>
            </div>
            <div *ngIf="templates.length > 0">
                <table class="table table-fixed table-hover">
                    <thead>
                    <tr>
                        <th class="col-42 col-lg-44 pl-5" translate>Policy</th>
            <!--            TODO: Reimplement Region & Vertical https://zube.io/monsido/monsido/c/21967 -->
            <!--            <th class="col-xs-12 col-lg-10" translate>-->
            <!--                Vertical-->
            <!--            </th>-->
            <!--            <th class="col-xs-4 col-lg-4" translate>Country</th>-->
                        <th class="col-6 col-lg-4">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody class="card panel-monsido-card">
                    <tr *ngFor="let template of templates; trackBy: trackByIndex">
                        <td class="text-v-middle text-ellipsis pl-5 py-4">
                            <div class="max-width d-inline-block">
                                <div class="d-flex align-items-center">
                                    <span class="fa-lg mr-2 text-link" aria-hidden="true" [ngClass]="template.icon"></span>
                                    <span class="mr-auto">{{ template.name }}</span>
                                    <span class="label label-policy-new py-1 px-2" *ngIf="template.new" translate>New</span>
                                </div>
                            </div>
                        </td>
            <!--            TODO: Reimplement Region & Vertical https://zube.io/monsido/monsido/c/21967 -->
            <!--            <td class="text-v-middle">-->
            <!--                    <span class="fa-stack fa-lg"-->
            <!--                          *ngFor="let vertical of template.vertical; trackBy: trackByIndex"-->
            <!--                          ngbTooltip="{{getVerticalDescription(vertical)}}"-->
            <!--                          [triggers]="'focus hover'"-->
            <!--                          [tooltipClass]="'text-ellipsis'"-->
            <!--                          [placement]="'bottom'">-->
            <!--                        <span class="fas fa-circle fa-stack-2x"-->
            <!--                              [ngClass]="getVerticalBackground(vertical)"></span>-->
            <!--                        <span class="fa-stack-1x"-->
            <!--                              [ngClass]="[getVerticalColor(vertical), getVerticalIcon(vertical)]">-->
            <!--                        </span>-->
            <!--                    </span>-->
            <!--            </td>-->
            <!--            <td class="text-v-middle">-->
            <!--                    <span class="fa-stack fa-lg"-->
            <!--                          *ngFor="let country of template.country; trackBy: trackByIndex"-->
            <!--                          ngbTooltip="{{getCountryDescription(country)}}"-->
            <!--                          [triggers]="'focus hover'"-->
            <!--                          [tooltipClass]="'text-ellipsis'"-->
            <!--                          [placement]="'bottom'">-->
            <!--                          <span class="fas fa-circle fa-stack-2x text-link"></span>-->
            <!--                          <span class="fa-stack-1x fa-inverse" [ngClass]="getCountryIcon(country)">-->
            <!--                          </span>-->
            <!--                    </span>-->
            <!--            </td>-->
                        <td class="text-right text-v-middle">
                            <button type="button" class="btn btn-border-radius btn-marine-blue" (click)="selectTemplate(template)" translate>
                                Add Policy
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class PolicyExchangeCenterViewsListComponent {
    @Input() templates: any[] = [];
    @Output() chooseTemplate = new EventEmitter<any>();

    constructor (private globalPolicyExchangeCenterTemplateService: GlobalPolicyExchangeCenterTemplateService) {}

    selectTemplate (template: any): void {
        this.chooseTemplate.emit({ template: { ...template } });
    }

    getSubjectIcon (subject: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getSubjectIcon(subject);
    }

    getVerticalIcon (vertical: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalIcon(vertical);
    }

    getVerticalDescription (vertical: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalDescription(vertical);
    }

    getVerticalBackground (vertical: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalBackground(vertical) || '';
    }

    getVerticalColor (vertical: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalColor(vertical);
    }

    getCountryIcon (country: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getCountryIcon(country);
    }

    getCountryDescription (country: any): string {
        return this.globalPolicyExchangeCenterTemplateService.getCountryDescription(country);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
